const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
const isLiveWebsite = window.location.hostname === "djpsmbd.jueducation.com" || window.location.hostname.includes("djpsmbd.jueducation");
const isLocalServer = window.location.hostname === "localhost";


let base_url;
let path;
let StudentImagePath;
let StaffImagePath;
let images;
let assets;
let root;
let admin_path;

if (isLocalhost) {
  base_url = "http://localhost:52476/api/";
 //  base_url = "https://djpsmbdapi.jueducation.com/api/";
  StaffImagePath = "http://localhost:52476/staff_images/";
  StudentImagePath = "http://localhost:52476/student_images/";
  images = "http://localhost:52476/images/";
  assets = "http://localhost:52476/assets/";
  root = "http://localhost:52476/";

  
} else if (isLiveWebsite) {
  base_url = "https://djpsmbdapi.jueducation.com/api/";
  StaffImagePath = "https://djpsmbdapi.jueducation.com/staff_images/";
  StudentImagePath = "https://djpsmbdapi.jueducation.com/student_images/";
  images = "https://djpsmbdapi.jueducation.com/images/";
  assets = "https://djpsmbdapi.jueducation.com/assets/";
  root = "https://djpsmbdapi.jueducation.com/";
} else {
  // Fallback to production settings for any other domain
  base_url = "https://djpsmbdapi.jueducation.com/api/";
  StaffImagePath = "https://djpsmbdapi.jueducation.com/staff_images/";
  StudentImagePath = "https://djpsmbdapi.jueducation.com/student_images/";
  images = "https://djpsmbdapi.jueducation.com/images/";
  assets = "https://djpsmbdapi.jueducation.com/assets/";
  root = "https://djpsmbdapi.jueducation.com/";
} 

//SeRveR*324*
// Registration No: 8710
//34402-7260112-2
//12345678

/*For School
Admin
Admin*324*
*/
const config = {
  base_url,
  path,
  StudentImagePath,
  StaffImagePath,
  assets,
  root,
  images,
  admin_path,
  date_format: "DD/MM/YYYY",
  date_format_input: "YYYY-MM-DD",
};

export default config;
